import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getCurrentUser } from '../utils/api';

// Component to protect routes that require authentication
export const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Component to protect routes from game show users (role_id = 3)
export const RegularUserRoute = ({ children }) => {
  const user = getCurrentUser();
  
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  
  // Game show users (role_id = 3) should only access home page
  if (user?.role_id === 3) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

// Component to protect admin-only routes
export const AdminRoute = ({ children }) => {
  const user = getCurrentUser();
  
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  
  if (user?.role_id !== 1) {
    return (
      <div style={{ 
        padding: '2rem', 
        textAlign: 'center', 
        color: 'red' 
      }}>
        <h2>Access Denied</h2>
        <p>You need admin privileges to access this page.</p>
        {user?.role_id === 3 && (
          <p style={{ marginTop: '1rem', color: '#059669' }}>
            As a Game Show Player, you can only answer questions on the home page.
          </p>
        )}
      </div>
    );
  }
  
  return children;
}; 